import React from 'react';
import PropTypes from 'prop-types';
import * as iconStyles from '../../styles/icons.css';
import * as styles from './accordion.css';

class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: props.visible,
    };
  }

  render() {
    const { name, children, className } = this.props;
    const { visible } = this.state;

    const icon = [
      visible ? iconStyles.iconMinus : iconStyles.iconPlus,
      styles.icon,
    ].join(' ');

    return (<div className={styles.wrapper}>
      <span className={styles.header}>
        <button
          className={styles.toggle}
          onClick={() => this.setState({ visible: !visible })}
        >
          <i className={icon} />
          <span className={className}>{ name }</span>
        </button>
      </span>
      { (visible) ? <div className={styles.content}>{ children }</div> : null }
    </div>);
  }
}

Accordion.defaultProps = {
  name: '',
  visible: false,
  className: '',
};

Accordion.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
};

export default Accordion;



// WEBPACK FOOTER //
// ./app/components/accordion/index.js